import styled from '@emotion/styled'
import { Button } from '../button/Button'
import { borderRadius, colors, fontSize, spacing } from '../../foundation'

export const PaginationPageInput = styled.input({
  border: `1px solid ${colors.GRAYSCALE.X30}`,

  appearance: 'textfield',
  textAlign: 'center',
  fontWeight: 'bold',
  display: 'block',

  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    appearance: 'none',
    margin: 0,
  },
})

export const PaginationContainer = styled.div({
  display: 'flex',
  fontSize: fontSize.X12,

  '> .item': {
    width: 32,
    height: 32,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  '.total': {
    width: 'auto',
    paddingLeft: spacing.X12,
    paddingRight: spacing.X12,
  },
})

export const PaginationButton = styled(Button)(
  {
    margin: 0,
    padding: 0,
    borderRadius: 0,

    '&:first-of-type': {
      borderTopLeftRadius: borderRadius.X8,
      borderBottomLeftRadius: borderRadius.X8,
    },

    '&:last-of-type': {
      borderTopRightRadius: borderRadius.X8,
      borderBottomRightRadius: borderRadius.X8,
    },
  },

  ({ disabled }) => {
    const fill = disabled ? colors.GRAYSCALE.X30 : colors.GRAYSCALE.X70

    return {
      svg: { fill },
    }
  }
)
